<template>
  <div>
    <!-- Hero Section -->
    <section class="relative pt-20 pb-20 mt-20 bg-center bg-cover"
      style="background-image: url('https://ai-public.mastergo.com/ai/img_res/945c9ce26094544017287e13dfc4aef8.jpg')">
      <div class="absolute inset-0 gradient-overlay"></div>
      <div class="container relative z-10 flex flex-col justify-center h-full px-4 mx-auto">
        <h1 class="text-5xl md:text-6xl font-['Playfair_Display'] text-white font-bold mb-4">{{ $t('views.Contact.091378-0') }}</h1>
        <p class="max-w-2xl text-xl text-white md:text-2xl">{{ $t('views.Contact.091378-1') }}</p>
      </div>
    </section>

    <!-- 联系客服 -->
    <section class="py-20">
      <div class="container px-4 mx-auto">
        <div class="flex flex-col items-center justify-center max-w-2xl p-8 mx-auto bg-white rounded-lg shadow-lg">
          <img 
            src="https://ai-public.mastergo.com/ai/img_res/b75e23fea5ac99fb336cdde0958b21bc.jpg" 
            :alt="$t('views.Contact.559433-0')" 
            class="object-cover w-24 h-24 mb-6 border-2 rounded-full border-gold-500"
          />
          <div class="mb-6 text-center">
            <h3 class="text-xl font-bold text-gray-800">{{ $t('views.Contact.559433-1') }}</h3>
            <p class="text-gray-600">{{ $t('views.Contact.559433-2') }}</p>
            <p class="font-medium text-gold-500">{{ $t('views.Contact.559433-3') }}</p>
          </div>
          <div class="">
           
            <button 
              @click="contactUs"
              class="flex items-center justify-center px-3 py-2 space-x-2 font-medium text-white transition-colors bg-gray-800 rounded-lg hover:bg-gray-700"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
              <span>{{ $t('views.Contact.559433-4') }}</span>
            </button>
          </div>
        </div>
      </div>
    </section>

  
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import contactMixin from '@/mixins/contactMixin'
export default {
  name: 'ContactPage',
  mixins: [contactMixin],
  methods: {
    submitForm() {
     
      Swal.fire({
        icon: 'success',
        title: this.$t('views.Contact.738902-0'),
        text: this.$t('views.Contact.738902-1'),
        confirmButtonColor: '#DAA520'
      })
    }
  }
}
</script>

<style scoped>
.gradient-overlay {
  background: linear-gradient(90deg, rgba(25, 118, 210, 0.95) 0%, rgba(13, 71, 161, 0.8) 100%);
}

.contact-form input:focus,
.contact-form textarea:focus {
  outline: none;
  border-color: #DAA520;
  box-shadow: 0 0 0 2px rgba(218, 165, 32, 0.2);
}
</style>